import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const translations = {
  sr: {
    nav: {
      home: 'Početna',
      about: 'O nama',
      tickets: 'Avio karte',
      business: 'Poslovna putovanja',
      offers: 'Ponude',      inspiration: 'Inspiracija',      services: 'Usluge',
      contact: 'Kontakt',
      switchTo: 'EN',
      switchLabel: 'Prebaci na engleski',
    },
    hero: {
      // title: 'Unidea Travel',
      // subtitle: 'Više od puta',
      scroll: 'Skroluj',
    },
    stats: {
      items: [
        { number: '11,263 km', label: 'Maksimalni domet' },
        { number: '12 + 1', label: 'Kapacitet putnika' },
        { number: '14 hrs', label: 'Trajanje leta' },
        { number: '15,544 m', label: 'Kružna visina' },
      ],
    },
    floorPlan: {
      title: 'Raspored aviona',
    },
    offers: {
    //   title: 'Ponude',
      paragraphs: [
        'Upoznajte naše redovne ponude osmišljene da vam pruže kvalitetna i pristupačna putovanja, prilagođena različitim destinacijama i stilovima odmora.',
        'Svaka ponuda obuhvata pažljivo organizovan aranžman koji spaja udobnost, dobru cenu i prijatno iskustvo putovanja.',
      ],
      cards: [
        {
          title: 'Specijalna ponuda Oman',
          image: 'oman.jpeg',
          description: [
            'Period putovanja - oktobar i novembar',
            'Cena uključuje:',
            'Avio karte sa svim taksama',
            'Hotelski smeštaj - 7 noćenja na bazi usluge noćenje sa doručkom.',
          ],
          details: [
            'Intercontinental Muscat 5* — Premium room od 1467 € po osobi',
            'W Muscat 5* — Wonderful room od 1585 € po osobi',
          ],
          images: ['images/interkontinental.jpeg', 'images/muskat.jpeg'],
        },
        {
          title: 'Specijalna ponuda za Dubai',
          image: 'dubai.jpeg',
          description: [
            'Period putovanja - oktobar i novembar',
            'Cena uključuje:',
            'Avio karte sa svim taksama',
            'Hotelski smeštaj - 5 noćenja na bazi navedene usluge',
          ],
          details: [
            'Sofitel Dubai Jumeirah Beach 5* — POLUPANSION PO CENI NOĆENJA SA DORUČKOM, Superior room od 1195 € po osobi',
            'W Dubai - The Palm 5* — POLUPANSION PO CENI NOĆENJA SA DORUČKOM, Wonderful room od 1480 € po osobi',
          ],
          images: ['images/sofitel.jpeg', 'images/palm.jpeg'],
        },
        {
          title: 'Maldivi',
          image: 'specijalna_ponuda_maldivi.jpeg',
          description: [
            'Period putovanja - oktobar i novembar',
            'Cena uključuje:',
            'Avio karte sa svim taksama',
            'Transfer od aerodroma do hotela',
            'Hotelski smeštaj 7 noćenja na bazi navedene usluge',
            '',
            'Coco Palm Dhuni Kolhu 5*',
            'ALL INCLUSIVE PO CENI POLUPANSIONA',
            'Beach villa od 2549 € po osobi',
            '',
            'Hard Rock Hotel Maldives 5 *',
            'PUN PANSION PO CENI POLUPANSIONA',
            'Silver sky studio od 2568 € po osobi',
            '',
            'Kuredhivaru Resort and Spa Maldives 5*',
            'PUN PANSION PO CENI POLUPANSIONA',
            'Overwater pool villa lagoon od 4389 € po osobi',
          ],
          details: [
            'Coco Palm Dhuni Kolhu 5* - all inclusive po ceni polupansiona, Beach villa od 2549 €',
            'Hard Rock Hotel Maldives 5* - pun pansion po ceni polupansiona, Silver sky studio od 2568 €',
            'Kuredhivaru Resort and Spa Maldives 5* - pun pansion po ceni polupansiona, Overwater pool villa lagoon od 4389 €',
          ],
          images: ['images/hotel_coco.jpeg', 'images/hotel_hard_rock.jpeg', 'images/hotel_spa.jpeg'],
        },
        {
          title: 'Mauricijus',
          image: 'mauricijus.jpeg',
          description: [
            'Paket aranžman',
            'Avio karta + 7 noćenja u hotelu',
            '',
            'Casuarina Resort & Spa 3* usluga na bazi polupansiona - od 1100 € po osobi',
            'Solana Beach 4* usluga na bazi polupansiona - od 1480 € po osobi',
            'Mauricia Beachcomber Resort 4* usluga na bazi all inclusive od 1840 € po osobi',
            'Canonnier Beachcomber 4+* usluga na bazi polupansiona - od 1855 € po osobi',
            '',
            'Cene su date kao primer putovanja u aprilu.',
            'Sami birate datum putovanja, grad polaska i dužinu boravka na destinaciji.',
            '*Ne savetujemo putovanje od januara do marta zbog kišne sezone.*',
          ],
          details: [
            'Casuarina Resort & Spa 3* - polupansion od 1100 € po osobi',
            'Solana Beach 4* - polupansion od 1480 € po osobi',
            'Mauricia Beachcomber Resort 4* - all inclusive od 1840 € po osobi',
            'Canonnier Beachcomber 4+* - polupansion od 1855 € po osobi',
          ],
          images: ['images/mauricijus.jpeg'],
        },
        {
          title: 'Šri Lanka',
          image: 'sri_lanka.jpeg',
          description: [
            'Kružna tura u saradnji sa vodećom lokalnom agencijom - od 1840 €',
            '9 noćenja na bazi polupansiona - luksuzan smeštaj u hotelima 4* i 5*',
            'doček na aerodromu i usluge vodiča i vozača na destinaciji',
            'svakodnevni izleti prema programu',
            '',
            'Ajurveda reset na Šri Lanki - od 1980 €',
            '7 noćenja na bazi punog pansiona u hotelu Siddhalepa Ayurveda Health Resort u deluxe sobi sa pogledom na more',
            'doček na aerodromu i usluge vodiča i vozača na destinaciji',
            'tretmani u trajanju od 2.5 h dnevno, savetovanja, besplatni časovi joge dva puta dnevno, besplatne poslastice i čajevi svako popodne, poseta fabrici prirodnih proizvoda, sesije meditacije i edukacija o Ajurveda terapijama.',
            '',
            'Navedene cene su prikazane po osobi, po trenutnoj raspoloživosti za boravak u visokoj sezoni od januara do marta.',
          ],
          details: [
            'Kružna tura od 1840 € po osobi - 9 noćenja, polupansion, vodič i vozač, izleti po programu',
            'Ajurveda reset od 1980 € po osobi - 7 noćenja, full board, Siddhalepa Ayurvedic Health Resort, tretmani i joga',
          ],
          images: ['images/sri_lanka.jpeg'],
        },
        {
          title: 'Novogodišnja putovanja',
          badge: 'Avionom',
          image: 'novogodisnja_putovanja.jpeg',
          description: [
            'ITALIJA',
            'Rim 28.decembar - 03.januar',
            'The Guardian Hotel 4* - 6 noćenja sa doručkom od 739 €',
            '',
            'Milano 28.decembar - 01.januar',
            'Hotel Manin 4* - 4 noćenja sa doručkom od 649 €',
            '',
            'ŠPANIJA',
            'Barselona 27.decembar - 01.januar',
            'Ikonik Ramblas 4* - 5 noćenja sa doručkom od 595 €',
            '',
            'Madrid *let iz Budimpeste* 28.decembar - 03.januar',
            'u cenu uključen parking na aerodromu u Budimpešti',
            'Hard Rock Hotel Madrid 4* - 5 noćenja sa doručkom 989 €',
            '',
            'PORTUGAL',
            'Lisabon 26.decembar - 02.jan',
            'Quinta Colina by Shiadu 4* - 8 noćenja sa doručkom od 699 €',
            '',
            'Porto 25.decembar - 01.januar',
            'Exe Essenzia Porto 4* - 7 noćenja sa doručkom od 689 €',
            '',
            '*DODATNI POPUST ZA REZERVACIJU HOTELSKOG SMEŠTAJA DO 27.DECEMBRA ZA SVE DESTINACIJE*',
            'Sve cene su prikazane po osobi, po trenutnoj raspoloživosti.',
          ],
          details: [
            'Italija: Rim i Milano aranžmani sa doručkom',
            'Španija: Barselona i Madrid aranžmani sa doručkom',
            'Portugal: Lisabon i Porto aranžmani sa doručkom',
            'Dodatni popust za rezervaciju hotelskog smeštaja do 27.decembra',
          ],
          images: ['images/novogodisnja_putovanja.jpeg'],
        },
      ],
    },
    ultra: {
      heading: 'Inspiracija',
      paragraph: 'Izaberite jednu od pažljivo odabranih destinacija koje smo pripremili za vas, i prepustite se uživanju u potpunom aranžmanu koji uključuje sve što vam je potrebno za bezbrižno putovanje.',
      direct: 'Direktan pristup privatnom putovanju',
      regions: [
        { name: 'Evropa', description: 'Prelepe obale, istorija i šarm urbane kulture.', image: 'images/evropa.jpeg' },
        { name: 'Azija', description: 'Egzotični pejzaži, bogata tradicija i kulinarske avanture.', image: 'images/azija.jpeg' },
        { name: 'Amerika', description: 'Dinamični gradovi i netaknuta priroda na obe strane kontinenta.', image: 'images/amerika.jpeg' },
        { name: 'Karibi', description: 'Plavi ceo, pesak i relaksacija uz hrsku ritma okeana.', image: 'images/karibi.jpeg' },
        { name: 'Afrika', description: 'Divlji safariji, spektakularne pustinje i živopisna kultura.', image: 'images/afrika.jpeg' },
        { name: 'Južna Amerika', description: 'Tropske džungle, planinske staze i živahne metropole.', image: 'images/juzna_amerika.jpeg' },
      ],
    },
    betterWay: {
    //   title: 'Bolji način putovanja',
      card1: {
        title: 'Putovanje sa ljubimcima',
        text: 'Putovanje sa ljubimcima znači udobnost i mir za vlasnike i njihove saputnike. Naš tim obezbeđuje neometane aranžmane, od dokumentacije do svih neophodnih detalja.',
      },
      card2: {
        title: 'Dostupnost 24/7',
        text: 'Naš tim je dostupan oko sat vremena da odgovori na svaki zahtev, bez obzira na vremensku zonu ili hitnost. Od last-minute aranžmana do personalizovanih usluga.',
      },
    },
    about: {
      title: 'O nama',
      paragraphs: [
        'UNIDEA je putnička agencija koja će Vam uvek pružiti profesionalnu podršku i pravim savetima učiniti poslovno ili turističko putovanje ugodno i po Vašoj meri.',
        'Sedište naše agencije je u Držićevoj ulici u Beogradu, u blizini Vukovog spomenika. Osnovani smo 2001. godine kao agencija koja je pružala usluge izdavanja avio karata, a danas se naše poslovanje proširilo na organizaciju i kreiranje poslovnih i individualnih turističkih putovanja.',
        'Od 2003. godine smo stalni akreditovani IATA agent (licenca br. 95-211211), ispunjavamo profesionalne standarde Međunarodne asocijacije vazdušnog transporta za promociju i prodaju međunarodnog vazdušnog prevoza putnika.',
        'Naši zaposleni imaju licence o završenom usavršavanju Međunarodni putnički agenti, kurs-461, kao i diplome za prodaju u globalnim rezervacionim sistemima Sabre, Amadeus i Farelogix.',
        'U dosadašnjem poslovanju uslužili smo preko 150.000 putnika i nastavljamo dalje sa istom motivacijom i željom da naše putnike učinimo zadovoljnim.',
        'Kontaktirajte nas već danas, odgovorićemo na sva vaša pitanja i dati Vam najbolju ponudu prema vašim željama i mogućnostima.',
      ],
    },
    tickets: {
      title: 'Avio karte',
      paragraphs: [
        'Kupovina avio karata – bez stresa i gubljenja vremena',
        'Kupovina avionskih karata može biti komplikovana, dugotrajna i zbunjujuća. Traženje povoljnih letova, upoređivanje cena, biranje najboljih opcija i briga oko rezervacija i dodatnih troškova zna da bude pravi izazov.',
        'Mi se brinemo o svemu umesto vas',
        'Zato smo tu mi – da vam maksimalno olakšamo ceo proces. Pronalazimo najbolje letove i brinemo o svemu, kako bi vaše putovanje počelo bez briga i komplikacija.',
        'Brzo, jednostavno i potpuno transparentno',
        'Bez beskrajnih pretraga, komplikovanih sajtova i skrivenih troškova, sve završavamo brzo, jednostavno i transparentno. Prepustite nama da se pobrinemo za vaše avio karte i posvetite se onome što je zaista važno – uživanju u vašem putovanju!',
      ],
      card1: {
        title: 'Kako to funkcioniše?',
        items: [
          'Vi kažete gde i kada želite da putujete',
          'Mi pronalazimo najbolje letove i opcije koje odgovaraju vašim potrebama',
          'Rezervišemo karte umesto vas i brinemo o svim detaljima',
        ],
      },
      card2: {
        title: 'Zašto izabrati nas?',
        items: [
          'Podrška 24/7 – uvek smo dostupni za sva vaša pitanja',
          'Stručnost – pronalazimo najbolje ponude za vas',
          'Transparentnost – bez skrivenih troškova',
        ],
      },
    },
    business: {
      title: 'Poslovna putovanja',
      paragraphs: [
        'Potpuna organizacija poslovnih putovanja',
        'Unidea Travel preuzima organizaciju korporativnih i privatnih poslovnih putovanja, ističući u potpunosti zadovoljstvo vaših potreba.',
        'Brza i pouzdana realizacija svih zahteva',
        'Dostavljajući svaki vaš zahtev dosledno i brzo, dogovaramo se za organizovano i sigurno putovanje. Istovremeno preuzimamo organizaciju pojedinačnih i grupnih učešća na izložbama, konferencijama, međunarodnim naučnim skupovima, kako u Srbiji, tako i u inostranstvu.',
      ],
      card1: {
        title: 'Usluge',
        items: [
          'Avio karte',
          'Hotelske rezervacije',
          'Individualna putovanja',
          'Kruzzeri/brodovi za krstarenje',
          'Transfere ili rent a-car',
          'Karte za Trajekte',
          'Vozne i autobuske karte',
          'Putno zdravstveno osiguranje',
          '24/7 podrška u putovanju',
        ],
      },
      card2: {
        title: 'Šta dobijate',
        items: [
          'Štedite novac sa našim niskim cenama',
          '80% manje vremena trošite na rezervacije i obradu podataka',
          'Usklađujemo sve Vaše rasporede',
          'Puna podrška 24/7',
          'Sveobuhvatni pristup organizaciji konferencija i događaja',
          'Organizacija poslovnih konferencija i događaja danas predstavlja mnogo više od same rezervacije prostora i zakazivanja termina.',
          'Planiranje i koordinacija kompletnog događaja',
          'Rezervacija prostora i tehničke opreme',
          'Organizacija smeštaja i prevoza za učesnike',
          'Angažovanje predavača i moderatora',
          'Obezbeđivanje catering usluga',
          'Logistika i podrška na licu mesta',
          'Stručan tim sa iskustvom u realizaciji poslovnih događaja',
          'Personalizovan pristup i prilagođavanje vašim ciljevima',
          'Ušteda vremena i resursa',
          'Visok nivo profesionalizma i fleksibilnosti',
          'Potpunu podršku od početka do kraja događaja',
        ],
      },
    },
    footer: {
      phoneLabel: 'Telefon',
      emailLabel: 'Email',
      addressLabel: 'Držićeva 9',
      copyright: '© 2026 Unidea travel. Sva prava zadržana.',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      tickets: 'Tickets',
      business: 'Business travel',
      offers: 'Offers',
      inspiration: 'Inspiration',
      services: 'Services',
      contact: 'Contact',
      switchTo: 'SR',
      switchLabel: 'Switch to Serbian',
    },
    hero: {
      //title: 'Unidea Travel',
     // subtitle: 'More than a journey',
      scroll: 'Scroll',
    },
    stats: {
      items: [
        { number: '11,263 km', label: 'Maximum operating range' },
        { number: '12 + 1', label: 'Passenger capacity' },
        { number: '14 hrs', label: 'Endurance' },
        { number: '15,544 m', label: 'Cruising altitude' },
      ],
    },
    floorPlan: {
      title: 'Aircraft Layout',
    },
    offers: {
      title: 'Business travel',
      paragraphs: [
        'Discover our regular offers designed to give you quality and affordable travel, tailored to different destinations and vacation styles.',
        'Each offer includes a carefully organized arrangement that combines comfort, good value, and a pleasant travel experience.',
      ],
      cards: [
        {
          title: 'Special offer Oman',
          image: 'oman.jpeg',
          description: 'An exclusive trip through desert landscapes, luxury hotels, and local culture.',
          details: ['Direct flights and transfers', 'Premium accommodation', 'Organized excursions'],
          images: ['images/interkontinental.jpeg', 'images/muskat.jpeg'],
        },
        {
          title: 'Special offer for Dubai',
          image: 'dubai.jpeg',
          description: [
            'Travel period - October and November',
            'Price includes:',
            'Air tickets with all taxes',
            'Hotel accommodation - 5 nights on the requested basis',
          ],
          details: [
            'Sofitel Dubai Jumeirah Beach 5* — HALF BOARD PER NIGHT WITH BREAKFAST, Superior room from 1195 € per person',
            'W Dubai - The Palm 5* — HALF BOARD PER NIGHT WITH BREAKFAST, Wonderful room from 1480 € per person',
          ],
          images: ['images/sofitel.jpeg', 'images/palm.jpeg'],
        },
        {
          title: 'Maldives',
          image: 'specijalna_ponuda_maldivi.jpeg',
          description: [
            'Travel period - October and November',
            'Price includes:',
            'Air tickets with all taxes',
            'Airport transfer to hotel',
            'Hotel accommodation 7 nights on the basis of the selected service',
            '',
            'Coco Palm Dhuni Kolhu 5*',
            'ALL INCLUSIVE AT HALF BOARD PRICE',
            'Beach villa from 2549 € per person',
            '',
            'Hard Rock Hotel Maldives 5*',
            'FULL BOARD AT HALF BOARD PRICE',
            'Silver sky studio from 2568 € per person',
            '',
            'Kuredhivaru Resort and Spa Maldives 5*',
            'FULL BOARD AT HALF BOARD PRICE',
            'Overwater pool villa lagoon from 4389 € per person',
          ],
          details: [
            'Coco Palm Dhuni Kolhu 5* - all inclusive at half board price, Beach villa from 2549 €',
            'Hard Rock Hotel Maldives 5* - full board at half board price, Silver sky studio from 2568 €',
            'Kuredhivaru Resort and Spa Maldives 5* - full board at half board price, Overwater pool villa lagoon from 4389 €',
          ],
          images: ['images/hotel_coco.jpeg', 'images/hotel_hard_rock.jpeg', 'images/hotel_spa.jpeg'],
        },
        {
          title: 'Mauritius',
          image: 'mauricijus.jpeg',
          description: [
            'Package arrangement',
            'Air ticket + 7 nights in a hotel',
            '',
            'Casuarina Resort & Spa 3* - half board service from 1100 € per person',
            'Solana Beach 4* - half board service from 1480 € per person',
            'Mauricia Beachcomber Resort 4* - all inclusive service from 1840 € per person',
            'Canonnier Beachcomber 4+* - half board service from 1855 € per person',
            '',
            'Prices are shown as an example for travel in April.',
            'You choose travel date, departure city and length of stay.',
            '*We do not recommend travel from January to March due to the rainy season.*',
          ],
          details: [
            'Casuarina Resort & Spa 3* - half board from 1100 € per person',
            'Solana Beach 4* - half board from 1480 € per person',
            'Mauricia Beachcomber Resort 4* - all inclusive from 1840 € per person',
            'Canonnier Beachcomber 4+* - half board from 1855 € per person',
          ],
          images: ['images/mauricijus.jpeg'],
        },
        {
          title: 'Sri Lanka',
          image: 'sri_lanka.jpeg',
          description: [
            'Round tour in cooperation with a leading local agency - from 1840 €',
            '9 nights on half board - luxury accommodation in 4* and 5* hotels',
            'airport greeting and guide/driver services at destination',
            'daily excursions according to the program',
            '',
            'Ayurveda reset in Sri Lanka - from 1980 €',
            '7 nights on full board at Siddhalepa Ayurveda Health Resort in a deluxe sea-view room',
            'airport greeting and guide/driver services at destination',
            'daily 2.5h treatments, consultations, free yoga classes twice daily, free snacks and teas every afternoon, visit to natural products factory, meditation sessions and Ayurveda therapy education.',
            '',
            'Listed prices are shown per person, based on current availability for high season stays from January to March.',
          ],
          details: [
            'Round tour from 1840 € per person - 9 nights, half board, guide and driver, excursions',
            'Ayurveda reset from 1980 € per person - 7 nights, full board, Siddhalepa Ayurvedic Health Resort, treatments and yoga',
          ],
          images: ['images/sri_lanka.jpeg'],
        },
        {
          title: 'New Year trips',
          badge: 'By air',
          image: 'novogodisnja_putovanja.jpeg',
          description: [
            'ITALY',
            'Rome 28 December - 03 January',
            'The Guardian Hotel 4* - 6 nights with breakfast from 739 €',
            '',
            'Milan 28 December - 01 January',
            'Hotel Manin 4* - 4 nights with breakfast from 649 €',
            '',
            'SPAIN',
            'Barcelona 27 December - 01 January',
            'Ikonik Ramblas 4* - 5 nights with breakfast from 595 €',
            '',
            'Madrid *flight from Budapest* 28 December - 03 January',
            'airport parking in Budapest included',
            'Hard Rock Hotel Madrid 4* - 5 nights with breakfast 989 €',
            '',
            'PORTUGAL',
            'Lisbon 26 December - 02 Jan',
            'Quinta Colina by Shiadu 4* - 8 nights with breakfast from 699 €',
            '',
            'Porto 25 December - 01 January',
            'Exe Essenzia Porto 4* - 7 nights with breakfast from 689 €',
            '',
            '*ADDITIONAL DISCOUNT FOR HOTEL RESERVATIONS MADE BY 27 DECEMBER FOR ALL DESTINATIONS*',
            'All prices are shown per person, based on current availability.',
          ],
          details: [
            'Italy: Rome and Milan packages with breakfast',
            'Spain: Barcelona and Madrid packages with breakfast',
            'Portugal: Lisbon and Porto packages with breakfast',
            'Additional discount for hotel reservations made by 27 December',
          ],
          images: ['images/novogodisnja_putovanja.jpeg'],
        },
      ],
    },
    ultra: {
      heading: 'Inspiration',
      paragraph: 'Choose one of our carefully selected destinations prepared for you, and let yourself enjoy a complete package that includes everything you need for a carefree journey.',
      direct: 'Direct access to private travel',
      regions: [
        { name: 'Europe', description: 'Beautiful coasts, rich history and charming urban culture.', image: 'images/evropa.jpeg' },
        { name: 'Asia', description: 'Exotic landscapes, rich traditions and culinary adventures.', image: 'images/azija.jpeg' },
        { name: 'America', description: 'Dynamic cities and untouched nature across the continents.', image: 'images/amerika.jpeg' },
        { name: 'Caribbean', description: 'Blue seas, white sand and relaxed island rhythms.', image: 'images/karibi.jpeg' },
        { name: 'Africa', description: 'Wild safaris, dramatic deserts and vibrant local culture.', image: 'images/afrika.jpeg' },
        { name: 'South America', description: 'Tropical jungles, mountain trails and lively cities.', image: 'images/juzna_amerika.jpeg' },
      ],
    },
    betterWay: {
    //   title: 'A Better Way to Fly',
      card1: {
        title: 'Traveling with Pets',
        text: 'Traveling with pets means comfort and peace of mind for both owners and their companions. ',
      },
      card2: {
        title: '24/7 Availability',
        text: 'Our team is available around the clock to handle any request, no matter the time zone or urgency. From last-minute flight arrangements to personalized services.',
      },
    },
    about: {
      title: 'About us',
      paragraphs: [
        'UNIDEA is a travel agency that will always provide you with professional support and make your business or leisure journey pleasant and tailored to your needs.',
        'Our agency is based on Držićeva Street in Belgrade, near the Vuk monument. Founded in 2001 as a ticketing agency, our business has since expanded to organizing and creating corporate and individual tourist trips.',
        'Since 2003, we have been a permanent accredited IATA agent (license no. 95-211211), meeting the professional standards of the International Air Transport Association for the promotion and sale of international passenger air transport.',
        'Our staff hold certificates in International Passenger Agent training, course-461, as well as diplomas for sales in global reservation systems Sabre, Amadeus and Farelogix.',
        'In our business to date, we have served over 150,000 passengers and continue with the same motivation and desire to make our passengers satisfied.',
        'Contact us today, and we will answer all your questions and offer you the best proposal according to your wishes and possibilities.',
      ],
    },
    tickets: {
      title: 'Flight tickets',
      paragraphs: [
        'Buying flight tickets – without stress and wasted time',
        'Buying airline tickets can be complicated, time-consuming and confusing. Finding affordable flights, comparing prices, selecting the best options and worrying about reservations and extra costs can be a real challenge.',
        'We take care of everything for you',
        'That’s why we are here – to make the whole process as easy as possible for you. We find the best flights and take care of everything so that your journey starts without worries and complications.',
        'Fast, simple and completely transparent',
        'Without endless searches, complicated websites and hidden costs, we complete everything quickly, simply and transparently. Leave it to us to take care of your flight tickets and focus on what really matters – enjoying your trip!',
      ],
      card1: {
        title: 'How it works',
        items: [
          'You tell us where and when you want to travel',
          'We find the best flights and options that match your needs',
          'We book the tickets for you and take care of all the details',
        ],
      },
      card2: {
        title: 'Why choose us',
        items: [
          'Support 24/7 – we are always available for your questions',
          'Expertise – we find the best offers for you',
          'Transparency – no hidden costs',
        ],
      },
    },
    business: {
      title: 'Business travel',
      paragraphs: [
        'Complete business travel organization',
        'Unidea Travel takes over the organization of corporate and private business trips, fully emphasizing the satisfaction of your needs.',
        'Fast and reliable fulfillment of all requests',
        'Delivering every request consistently and quickly, we arrange organized and safe travel. We also take on the organization of individual and group participation at exhibitions, conferences, and international scientific gatherings, both in Serbia and abroad.',
      ],
      card1: {
        title: 'Services',
        items: [
          'Flight tickets',
          'Hotel reservations',
          'Individual trips',
          'Cruises/boats for cruising',
          'Transfers or rent a car',
          'Ferry tickets',
          'Train and bus tickets',
          'Travel health insurance',
          '24/7 travel support',
        ],
      },
      card2: {
        title: 'What you get',
        items: [
          'Save money with our low fares',
          'Spend 80% less time on reservations and data processing',
          'We coordinate all your schedules',
          'Full 24/7 support',
          'Comprehensive approach to conference and event planning',
          'Event planning and coordination of the complete event',
          'Venue and technical equipment booking',
          'Accommodation and transport organization for participants',
          'Speaker and moderator engagement',
          'Catering services procurement',
          'Logistics and on-site support',
          'A professional team experienced in business event execution',
          'Personalized approach and adaptation to your goals',
          'Time and resource savings',
          'High level of professionalism and flexibility',
          'Complete support from start to finish',
        ],
      },
    },
    footer: {
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      addressLabel: 'Worldwide Operations',
      copyright: '© 2026 Unidea travel. All rights reserved.',
    },
  },
};

const LanguageContext = createContext({
  lang: 'sr',
  setLang: () => {},
  t: translations.sr,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('sr');

  useEffect(() => {
    const saved = window.localStorage.getItem('unidea-language');
    if (saved === 'sr' || saved === 'en') {
      setLang(saved);
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem('unidea-language', lang);
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
